import {
  Button,
  Collapse,
  Flex,
  Form,
  FormListFieldData,
  Popconfirm
} from 'antd'
import { Trash } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { Person } from './types'

type Props = {
  personsKey?: string
  showAddAction?: boolean
  showDeleteAction?: (name: number, person?: Person) => boolean
  collapseTitle?: (field: FormListFieldData) => React.ReactNode
  children?: (field: FormListFieldData, persons: Person[]) => React.ReactNode
}

export const EditPersonsWrapper = ({
  personsKey = 'persons',
  showAddAction,
  showDeleteAction,
  collapseTitle,
  children
}: Props) => {
  const { t } = useTranslation()
  const persons =
    Form.useWatch<Person[]>(personsKey, {
      preserve: true
    }) || []

  return (
    <Form.List name={personsKey}>
      {(fields, { add, remove }) => (
        <Flex vertical gap={16}>
          <Collapse
            key={fields.length}
            defaultActiveKey={fields
              .slice(0, 10)
              .map(({ name }) => String(name))}
            items={fields.map((field) => ({
              key: String(field.name),
              label:
                collapseTitle?.(field) ||
                t('person_number', { number: field.name + 1 }),
              extra: showDeleteAction?.(field.name, persons?.[field.name]) && (
                <Popconfirm
                  title={t('delete_individual_person')}
                  okText={t('delete')}
                  cancelText={t('cancel')}
                  onConfirm={() => remove(field.name)}
                  onCancel={(e) => e?.stopPropagation()}
                >
                  <Button
                    type="primary"
                    icon={<Trash size={16} />}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Popconfirm>
              ),
              children: children?.(field, persons || [])
            }))}
          />

          {showAddAction && (
            <Flex justify="end">
              <Button type="primary" onClick={() => add()}>
                {t('add_new_person')}
              </Button>
            </Flex>
          )}
        </Flex>
      )}
    </Form.List>
  )
}
